import UniversalCookie from 'universal-cookie';
import client from './apiClient';
import {
  CreateOrUpdateWaterfallVersionViewModel,
  CreateOrUpdateWaterfallViewModel,
  WaterfallVersionViewModel,
  WaterfallViewModel,
  FieldMetadata,
  OperatorInfo,
  EnumValueData,
  MetadataContextType,
} from '../models/waterfall';
import { Constants } from '../utils/constants';

const cookie = new UniversalCookie({ path: '/' });

client.interceptors.request.use(async (config) => {
  const tenantId: string | null | undefined = localStorage.getItem(Constants.authorization.tenantId) || null;
  const access_token: string | undefined = cookie.get(Constants.authorization.accessToken) || null;

  config.headers['X-TenantId'] = tenantId;
  config.headers['Authorization'] = `Bearer ${access_token}`;

  return config;
});

export const getAll = async (): Promise<WaterfallViewModel[]> => {
  const { data } = await client.get<WaterfallViewModel[]>('/waterfall');
  return data;
};

export const get = async (id: number): Promise<WaterfallViewModel> => {
  const { data } = await client.get<WaterfallViewModel>(`/waterfall/${id}`);
  return data;
};

export const deleteWaterfall = async (id: number): Promise<void> => {
  await client.delete(`/waterfall/${id}`);
};

export const create = async (payload: CreateOrUpdateWaterfallViewModel): Promise<WaterfallViewModel> => {
  const { data } = await client.post<WaterfallViewModel>('/waterfall', payload);
  return data;
};

export const update = async (payload: CreateOrUpdateWaterfallViewModel): Promise<WaterfallViewModel> => {
  const { data } = await client.put<WaterfallViewModel>('/waterfall', payload);
  return data;
};

export const getAllVersions = async (): Promise<WaterfallVersionViewModel[]> => {
  const { data } = await client.get<WaterfallVersionViewModel[]>('/waterfall-version');
  return data;
};

export const getVersion = async (id: number): Promise<WaterfallVersionViewModel> => {
  const { data } = await client.get<WaterfallVersionViewModel>(`/waterfall-version/${id}`);
  return data;
};

export const createVersion = async (
  payload: CreateOrUpdateWaterfallVersionViewModel
): Promise<WaterfallVersionViewModel> => {
  const { data } = await client.post<WaterfallVersionViewModel>('/waterfall-version', payload);
  return data;
};

export const updateVersion = async (
  payload: CreateOrUpdateWaterfallVersionViewModel
): Promise<WaterfallVersionViewModel> => {
  const { data } = await client.put<WaterfallVersionViewModel>('/waterfall-version', payload);
  return data;
};

export const deleteVersion = async (id: number): Promise<void> => {
  await client.delete(`/waterfall-version/${id}`);
};

export const getFieldMetadata = async (contextType: MetadataContextType): Promise<FieldMetadata[]> => {
  const { data } = await client.get<FieldMetadata[]>(`/expressions/field-metadata/${contextType}`);
  return data;
};

export const getOperators = async (): Promise<OperatorInfo[]> => {
  const { data } = await client.get<OperatorInfo[]>('/expressions/operators');
  return data;
};

export const getEnumValues = async (enumTypeName: string): Promise<EnumValueData[]> => {
  const { data } = await client.get<EnumValueData[]>(`/common/enums/${enumTypeName}`);
  return data;
};
